'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = require('./api');

var _util = require('./util');

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  parseStream: _api.parseStream,
  parseFile: _api.parseFile,
  parseStringSync: _api.parseStringSync,
  formatSync: _api.formatSync,
  formatStream: _api.formatStream,
  formatFile: _api.formatFile,
  util: util
};